import React from 'react';
import { useSelector } from 'react-redux';
import CollapsibleLinks from './CollapsibleLinks';
import { FaCamera } from 'react-icons/fa';
import EmptyContent from '../../EmptyContent';

function LinksTab() {
  const { segments } = useSelector((state) => state?.hotbar);

  // Calculate the total number of links
  const totalLinks = segments?.reduce((sum, segment) => {
    return sum + (segment?.items?.links?.length || 0);
  }, 0);

  return (
    <>
      {totalLinks > 0 ? (
        segments?.map((segment) =>
          segment?.items?.links?.length ? (
            <CollapsibleLinks
              key={segment.title} // Assuming title is unique
              links={segment.items.links}
              icon={<FaCamera />}
              title={segment.title}
              segmentColor={segment.segmentColor}
            />
          ) : null
        )
      ) : (
        <EmptyContent />
      )}
    </>
  );
}

export default LinksTab;
